import React from 'react';
import Icon from '../../../components/AppIcon';

const ProfileProgressIndicator = ({ currentStep = 1, totalSteps = 4 }) => {
  const steps = [
    { id: 1, title: 'اطلاعات پایه', description: 'نام و تخصص' },
    { id: 2, title: 'تجربه کاری', description: 'سابقه و مهارت' },
    { id: 3, title: 'اطلاعات تماس', description: 'شماره و آدرس' },
    { id: 4, title: 'تکمیل پروفایل', description: 'بررسی نهایی' }
  ];

  const getStepStatus = (stepId) => {
    if (stepId < currentStep) return 'completed';
    if (stepId === currentStep) return 'current';
    return 'upcoming';
  };

  const getStepIcon = (stepId, status) => {
    if (status === 'completed') return 'Check';
    if (status === 'current') return 'Circle';
    return 'Circle';
  };

  const progressPercentage = ((currentStep - 1) / (totalSteps - 1)) * 100;

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-card-foreground">
          پیشرفت تکمیل پروفایل
        </h3>
        <span className="text-sm text-muted-foreground">
          {currentStep} از {totalSteps}
        </span>
      </div>
      {/* Progress Bar */}
      <div className="relative mb-6">
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
      {/* Steps */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {steps?.map((step) => {
          const status = getStepStatus(step?.id);
          return (
            <div key={step?.id} className="flex flex-col items-center text-center">
              {/* Step Icon */}
              <div className={`w-8 h-8 rounded-full flex items-center justify-center mb-2 transition-smooth ${
                status === 'completed' 
                  ? 'bg-success text-success-foreground' 
                  : status === 'current' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground'
              }`}>
                <Icon 
                  name={getStepIcon(step?.id, status)} 
                  size={16} 
                />
              </div>
              {/* Step Info */}
              <div className="space-y-1">
                <h4 className={`text-xs font-medium ${
                  status === 'current' ?'text-primary' 
                    : status === 'completed' ?'text-success' :'text-muted-foreground'
                }`}>
                  {step?.title}
                </h4>
                <p className="text-xs text-muted-foreground">
                  {step?.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileProgressIndicator;